import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FileSaver from "file-saver";
import Icons from "./Icons";
import config from "../../../config/configureSettings";
import { downloadUserGuideRequestActionCreator } from "../../../../modules/admin/dashboard/redux/actions/AdminDashboardActions";
import {
  getUserGuide,
  getUserGuideFilename,
} from "../../../../modules/admin/dashboard/redux/selectors/AdminDashboardSelectors";
import { httpOnlySecurityService } from "../../../../externals/iam";

class CapeUserGuideLinkContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      showOnLoadingUserGuide: false,
      status: "open",
    };
  }

  componentDidUpdate(prevProps) {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.guide !== prevProps.guide && this.props.guide !== "") {
      // eslint-disable-next-line react/destructuring-assignment
      if (this.state.status === "open") {
        this.openUrl();
        // eslint-disable-next-line react/destructuring-assignment
      } else if (this.state.status === "download") {
        this.downloadUrl();
      }
    }
  }

  onClickUserGuide = () => {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.guide === "") {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.downloadUserGuideRequestActionCreator();
      this.setState({
        // eslint-disable-next-line react/no-unused-state
        showOnLoadingUserGuide: true,
        status: "open",
      });
    } else {
      this.openUrl();
    }
  };

  downloadUserGuide = () => {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.guide === "") {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.downloadUserGuideRequestActionCreator();
      this.setState({
        // eslint-disable-next-line react/no-unused-state
        showOnLoadingUserGuide: true,
        status: "download",
      });
    } else {
      this.downloadUrl();
    }
  };

  openUrl = () => {
    // eslint-disable-next-line no-undef,react/destructuring-assignment
    const file = new File([this.props.guide], this.props.filename, {
      type: "application/pdf",
    });
    const fileURL = window.URL.createObjectURL(file);
    const uriWithInnerRef =
      fileURL +
      // eslint-disable-next-line no-nested-ternary,react/destructuring-assignment
      (this.props.reportCode
        ? // eslint-disable-next-line no-nested-ternary,react/destructuring-assignment, prefer-template
          this.props.pointerType && this.props.pointerType === "pageNo"
          ? this.props.pdfPageNo === 1
            ? ""
            : "#page=" + this.props.pdfPageNo
          : "#" + this.props.pdfNamedDestination
        : "");
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      showOnLoadingUserGuide: false,
    });
    window.open(uriWithInnerRef, "_blank");
  };

  downloadUrl = () => {
    // const file = new Blob([this.props.guide], { type: 'application/pdf' });
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      showOnLoadingUserGuide: false,
    });
    FileSaver.saveAs(
      // eslint-disable-next-line react/destructuring-assignment
      new window.Blob([this.props.guide], { type: "application/octet-stream" }),
      // eslint-disable-next-line react/destructuring-assignment
      this.props.filename
    );
  };

  render() {
    const isLoggedIn = httpOnlySecurityService.isUserAuthenticated();
    return (
      <div className="main-guide-button">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a>
          {/* eslint-disable-next-line react/destructuring-assignment */}
          <Icons.Custom
            name="question-circle"
            className={`pdf-icon-${isLoggedIn}`}
          />
        </a>
        <div className="download-menu">
          <ul>
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <a onClick={this.onClickUserGuide} className="download-menu-item">
                View Guide
              </a>
            </li>
            <li>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <div
                onClick={this.downloadUserGuide}
                className="download-menu-item"
              >
                Download Guide
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const currentReportCode = state.userData
    ? state.userData.currentReportCode
    : "";
  const { pointerType } = config.userGuide;
  // eslint-disable-next-line no-shadow
  const report = config.userGuide.reports.filter(
    (report) => report.reportCode === currentReportCode
  );
  const pdfNamedDestination =
    report && report.length > 0 ? report[0].destinationName : "";
  const pdfPageNo = report && report.length > 0 ? report[0].pageNo : 1;
  const guide = getUserGuide(state);
  const filename = getUserGuideFilename(state);
  return {
    pointerType,
    reportCode: currentReportCode,
    pdfPageNo,
    pdfNamedDestination,
    guide,
    filename,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      downloadUserGuideRequestActionCreator,
    },
    dispatch
  );

CapeUserGuideLinkContainer.propTypes = {
  pointerType: PropTypes.string,
  reportCode: PropTypes.string,
  pdfNamedDestination: PropTypes.string,
  pdfPageNo: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  guide: PropTypes.arrayOf(PropTypes.object),
  filename: PropTypes.string,
  downloadUserGuideRequestActionCreator: PropTypes.func,
};
CapeUserGuideLinkContainer.defaultProps = {
  pointerType: "",
  reportCode: "",
  pdfNamedDestination: "",
  pdfPageNo: 1,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CapeUserGuideLinkContainer);
